// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3ilv7","overflowX":"styles-module--overflowX--2b4Vb"};